export default "__VITE_ASSET__DMozu4_3__"